import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';

// Keys gravadas pelo servidor quando a disponibilidade muda sem motivo
// (PauseReason::IMPLICIT_LABELS) — não são cadastro, aparecem só no relatório.
const IMPLICIT_KEYS = ['busy', 'offline'];

// Leitura dos motivos de pausa da conta (store agentPauses). `reason` em todo
// lugar (timeline, painel supervisor, membro de fila) é a KEY do motivo; o
// nome e o limite saem daqui.
export function usePauseReasons() {
  const { t } = useI18n();
  const store = useStore();

  const reasons = computed(() => store.getters['agentPauses/getReasons']);
  const byKey = computed(() =>
    Object.fromEntries(reasons.value.map(reason => [reason.key, reason]))
  );

  // Só os ativos: o que o agente/supervisor pode escolher agora.
  const options = computed(() =>
    store.getters['agentPauses/getActiveReasons'].map(reason => ({
      value: reason.key,
      label: reason.name,
      limitSeconds: reason.max_duration_seconds,
    }))
  );

  // Key fora do cadastro (legado gravado antes do cadastro por conta) volta
  // crua — visível como está, nunca inventada.
  const reasonLabel = key => {
    if (!key) return '';
    if (IMPLICIT_KEYS.includes(key)) {
      return t(`AGENT_PAUSE.IMPLICIT.${key.toUpperCase()}`);
    }
    return byKey.value[key]?.name ?? key;
  };

  // nil = sem limite: nunca sinaliza.
  const limitSeconds = key => byKey.value[key]?.max_duration_seconds ?? null;

  // Estourar o limite NÃO encerra a pausa — só pinta de vermelho.
  const isOverdue = (key, elapsedSeconds) => {
    const limit = limitSeconds(key);
    return limit !== null && elapsedSeconds > limit;
  };

  return { options, reasonLabel, limitSeconds, isOverdue };
}
